module.exports = __webpack_public_path__ + "img/accumulated_mileage.547c2a7a.png";